/* PRESTIGÉ theme — minimal vanilla JS (no dependencies) */
(function () {
  'use strict';

  /* ---- Mobile menu -------------------------------------------------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var close = document.querySelector('[data-menu-close]');
    if (!toggle || !menu) return;
    function open() { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { menu.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* ---- Product: size / variant selection ---------------------------- */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var variantsEl = form.querySelector('[data-variants]');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceEl = document.querySelector('[data-price]');
    var buttons = form.querySelectorAll('[data-size]');

    function select(variant, btn) {
      buttons.forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      if (btn) btn.setAttribute('aria-checked', 'true');
      if (idInput) idInput.value = variant.id;
      if (variant.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = 'Add to Cart — ' + variant.option;
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Sold Out — ' + variant.option;
      }
      if (priceEl && variant.price != null) priceEl.textContent = variant.priceFormatted;
    }

    buttons.forEach(function (btn) {
      var v = variants.find(function (x) { return String(x.id) === btn.getAttribute('data-variant-id'); });
      if (!v) return;
      btn.addEventListener('click', function () { select(v, btn); });
    });

    // preselect: first available (or the pre-checked M if present)
    var pre = form.querySelector('[data-size][aria-checked="true"]');
    if (pre) {
      pre.click();
    } else {
      var firstAvail = null;
      buttons.forEach(function (btn) {
        if (firstAvail) return;
        var v = variants.find(function (x) { return String(x.id) === btn.getAttribute('data-variant-id'); });
        if (v && v.available) firstAvail = btn;
      });
      (firstAvail || buttons[0]) && (firstAvail || buttons[0]).click();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initProductForm();
  });
})();
